import type { Asset } from "../assetTypes.ts";

export const haveAsset = <A extends Asset>(asset: A | undefined | null) =>
  asset &&
  asset.source &&
  (("url" in asset.source && asset.source.url) || ("assetId" in asset.source && asset.source.assetId));
